import { useDispatch } from 'react-redux';
import { logoutUser } from 'services/authservices';
import { getDecodedToken, transformAuthUser } from 'utils/utils';

const useGetUserDetails = () => {
    const dispatch = useDispatch();
    const token = localStorage.getItem('token');
    
    var decoded = getDecodedToken(token);
    
    if (!decoded) {
        logoutUser(dispatch);
    } else {
        const flattenedUser = transformAuthUser(decoded);
        return { flattenedUser };
    }
};

export default useGetUserDetails;
